import Joi from 'joi';
import CHECKOUT_ERRORS from '../../constants/checkout-error-enums';
import { emailRegex } from '../../helpers/is-email';

// min and max values taken from EMV Secure Remote Commerce Specifications – API v1.1
const ConsumerObject = Joi.object()
  .keys({
    consumerIdentity: Joi.object()
      .keys({
        identityProvider: Joi.string()
          .valid('SRC')
          .optional(),
        identityType: Joi.string()
          .valid('EMAIL_ADDRESS') // per spec MOBILE_PHONE_NUMBER is also a valid type, but not for phase 1 of PSP
          .optional(), // per F20000 consumer identity values no longer required
        identityValue: Joi.string()
          .max(255)
          .regex(emailRegex)
          .optional()
          .error(errors => {
            errors.forEach(err => {
              // overwrite the error msg with generic error so regex string is not returned to merchant on error
              if (err.type === 'string.regex.base') {
                err.message = CHECKOUT_ERRORS.INVALID_PARAMETER;
              }
            });
            return errors;
          })
      })
      .optional(),
    firstName: Joi.string()
      .max(50)
      .optional(),
    fullName: Joi.string()
      .max(100)
      .optional(),
    lastName: Joi.string()
      .max(50)
      .optional(),
    mobileNumber: Joi.object()
      .keys({
        countryCode: Joi.string()
          .min(1)
          .max(4)
          .optional(), // per F20000 mobileNumber values no longer required
        phoneNumber: Joi.string()
          .min(4)
          .max(14)
          .optional()
      })
      .optional()
  })
  .optional();

export default ConsumerObject;
